import { bootstrapApplication } from '@angular/platform-browser';
import { AppComponent } from '@app';
import { appConfig } from '@app';

bootstrapApplication(AppComponent, appConfig).catch((err) =>
    console.error(err)
);
